import type { CcmTranslationsResponse } from '@arhs-fleetback/types/entities/ccm';

import { CCM_API_URL } from 'constants/ApiConstants';
import type { Action, GetRequest } from 'modules/global/generic.types';

import { CLEAR_CCM_DATA, FETCH_CCM_CONFIG, FETCH_CCM_DATA, INIT_CCM_LANGUAGE, SAVE_CCM_DATA, SELECT_CCM_LANGUAGE } from './actionTypes';
import type { EntityTypeEnum } from './types';

export const fetchCcmConfig = ({ entityType, id }: { entityType: EntityTypeEnum; id: string }): Action<GetRequest<undefined>> => ({
  type: FETCH_CCM_CONFIG,
  payload: {
    request: {
      method: 'GET',
      url: `${CCM_API_URL}/${entityType}/${id}/config`,
    },
  },
  meta: {
    '@app-request': true,
  },
});

export const fetchCcmData = (
  { entityType, id, language }: { entityType: EntityTypeEnum; id: string; language: string },
): Action<GetRequest<{ language: string }>> => ({
  type: FETCH_CCM_DATA,
  payload: {
    request: {
      method: 'GET',
      url: `${CCM_API_URL}/${entityType}/${id}/translations`,
      params: { language },
    },
  },
  meta: {
    '@app-request': true,
  },
});

export const selectCcmLanguage = (language: string) => ({
  type: SELECT_CCM_LANGUAGE,
  payload: language,
});

export const initCcmLanguage = (language: string) => ({
  type: INIT_CCM_LANGUAGE,
  payload: language,
});

export const saveCcmData = (
  { entityType, id, language, data }: { entityType: EntityTypeEnum; id: string; language: string; data: CcmTranslationsResponse },
) => ({
  type: SAVE_CCM_DATA,
  payload: {
    request: {
      method: 'PUT',
      url: `${CCM_API_URL}/${entityType}/${id}/translations`,
      params: { language },
      data,
    },
  },
  meta: {},
});

export const clearCcmData = () => ({ type: CLEAR_CCM_DATA });
